import { render, staticRenderFns } from "./declares.vue?vue&type=template&id=8a03945e&scoped=true&"
import script from "./declares.vue?vue&type=script&lang=js&"
export * from "./declares.vue?vue&type=script&lang=js&"
import style0 from "./declares.vue?vue&type=style&index=0&id=8a03945e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a03945e",
  null
  
)

export default component.exports